import { TFunction } from 'i18next';
import * as yup from 'yup';

import { viewsEndpoints } from '@/api/endpoints';
import { SUBSTRING_MIN_LENGTH } from '@/components/organisms/ConditionField/constants';
import {
  hasShortSubstringValue,
  isConditionComplete,
  toGroups,
} from '@/components/organisms/ConditionField/utils';
import { Condition } from '@/shared/types/condition';
import { ViewType } from '@/shared/types/views';
import { createNameFieldSchema } from '@/util/validation/schema-builders';

// If the name's string is longer than 16 characters, it will overflow the text in the component
const MAX_LENGTH = 16;
const MIN_LENGTH = 1;

export const schema = (t: TFunction, deskId: string, currentName?: string) =>
  yup.object({
    name: createNameFieldSchema({
      getEndpoint: (name) => viewsEndpoints.checkName(deskId, name, { desk_id: deskId }),
      min: MIN_LENGTH,
      max: MAX_LENGTH,
      excludeName: currentName,
    }),
    icon: yup.string(),
    type: yup.mixed<ViewType>().oneOf(Object.values(ViewType)).required(),
    condition: yup
      .mixed<Condition>()
      .required()
      .test(
        'not-empty',
        () => t('conversation.views.empty_condition_error'),
        (condition) => toGroups(condition).groups.length > 0
      )
      .test('complete', () => t('rules.editor.conditions_incomplete'), isConditionComplete)
      .test(
        'substring-length',
        () => t('validation.at_least', { 0: SUBSTRING_MIN_LENGTH }),
        (condition) => !hasShortSubstringValue(condition)
      ),
  });
